import { useToast } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { InputControl, SubmitButton } from "formik-chakra-ui";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useSigninUserMutation } from "../../store/api";
import { useAppDispatch } from "../../store/hook";
import { setUser } from "../../store/state/authSlice";
import {
  Flex,
  Box,
  Stack,
  Heading,
  Text,
  useColorModeValue,
  InputRightElement,
  Button,
  FormControl,
  InputGroup,
} from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

const Signin = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const navigate = useNavigate();
  const [signinUser, { data, isLoading, error, isError, isSuccess }] =
    useSigninUserMutation();
  const [showPassword, setShowPassword] = useState(false);

  if (isError && error) {
    toast({
      title: (error as any).data?.error?.error?.message || "Error",
      status: "error",
      duration: 5000,
    });
  }



  if (isSuccess && data && data.success) {
    dispatch(setUser({
      token: data?.data?.token?.access_token,
      user: data?.data?.user,
      refreshToken: data?.data?.token?.refresh_token
    }));
    localStorage.setItem("token", data?.data?.token?.access_token);
    localStorage.setItem("refreshToken", data?.data?.token?.refresh_token);
    localStorage.setItem("user", JSON.stringify(data?.data?.user));
    navigate("/");
  }


  return (
    <>
      <Formik
        initialValues={{ email: "", password: "" }}
        onSubmit={(values) => {
          signinUser({ ...values });
        }}
      >
        <Form>
          <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}>
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
              <Stack align={'center'}>
                <Heading color="teal" fontSize={'4xl'}>Sign in to your account</Heading>
              </Stack>
              <Box
                rounded={'lg'}
                bg={useColorModeValue('white', 'gray.700')}
                boxShadow={'lg'}
                p={8}>
                <Stack spacing={4}>
                  <InputControl
                    isRequired
                    name="email"
                    label="Email address"
                    color="teal"
                    inputProps={{
                      type: "email",
                      placeholder: "Enter Email...",
                    }}
                  />
                  <FormControl id="password" isRequired>
                    <InputGroup>
                      <InputControl
                        name="password"
                        label="Password"
                        color="teal"
                        inputProps={{
                          placeholder: "Enter Password...",
                          type: showPassword ? 'text' : 'password'
                        }}
                      />
                      <InputRightElement h={'full'} pt={8}>
                        <Button
                          variant={'ghost'}
                          onClick={() =>
                            setShowPassword((showPassword) => !showPassword)
                          }>
                          {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                  </FormControl>


                  <Stack spacing={10}>
                    <Flex justify="flex-end">
                      <Text as={Link} align="end" to="/forgot-password" fontSize="small" color="teal">
                        Forgot Password
                      </Text>
                    </Flex>
                    <SubmitButton _hover={{
                      bg: 'blue.500',
                    }} isLoading={isLoading}>Signin</SubmitButton>
                    <Flex justify="flex-end">
                      <Text as={Link} to="/signup" fontSize="small" color="teal">
                        Sign Up
                      </Text>
                    </Flex>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          </Flex>
        </Form>
      </Formik>
    </>
  );
};

export default Signin;





